import type { ReactNode } from 'react';
import Eyebrow from '../atoms/Eyebrow';
import { useAhaFlag } from '@/hooks/useAhaFlag';

// PR-UX-04 4-states · empty.
// Convention: uniform shape across all routes — eyebrow / title / sub / action.
//
// aha_forge v1 P2 seduction: when FYD_AHA_EMPTY_STATE_SEDUCTION is ON and the
// caller passes `illustrationSrc` + `seductionExtras`, render an extended
// surface (illustration + extra hint copy) above the standard block. Caller
// can pre-attach sample chips via `extras` — keeps EmptyState pure.
interface EmptyStateProps {
  eyebrow?: string;
  title: ReactNode;
  sub?: ReactNode;
  action?: ReactNode;
  className?: string;
  illustrationSrc?: string;
  illustrationAlt?: string;
  extras?: ReactNode;
}

export default function EmptyState({
  eyebrow,
  title,
  sub,
  action,
  className = '',
  illustrationSrc,
  illustrationAlt,
  extras,
}: EmptyStateProps) {
  const seduction = useAhaFlag('FYD_AHA_EMPTY_STATE_SEDUCTION');
  return (
    <div className={`text-center py-12 ${className}`} data-testid="empty-state">
      {seduction && illustrationSrc && (
        <img
          src={illustrationSrc}
          alt={illustrationAlt ?? ''}
          className="mx-auto mb-6 w-40 opacity-90"
          aria-hidden={!illustrationAlt}
        />
      )}
      {eyebrow && <Eyebrow tone="ash" className="mb-2">{eyebrow}</Eyebrow>}
      <h2 className="font-serif text-2xl font-medium mb-2">{title}</h2>
      {sub && <p className="text-base text-ink-3 max-w-md mx-auto mb-6">{sub}</p>}
      {action}
      {seduction && extras && <div className="mt-6">{extras}</div>}
    </div>
  );
}
